import {
    LOANREQUEST_STATUSES,
    SUB_STATUS_APPROVED,
    SUB_STATUS_IN_PROGRESS,
    SUB_STATUS_INITIAL,
    SUB_STATUS_OFFER_AT_BANK,
    SUB_STATUS_OFFER_AT_CUSTOMER,
} from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    divisionId: string | null;
    position?: number;
};

export const schemaTemplateResolver_GetStatusesWithDivisionMailTrigger = z
    .object({
        [LOANREQUEST_STATUSES.INITIAL]: z.record(z.nativeEnum(SUB_STATUS_INITIAL), z.boolean()),
        [LOANREQUEST_STATUSES.IN_PROGRESS]: z.record(z.nativeEnum(SUB_STATUS_IN_PROGRESS), z.boolean()),
        [LOANREQUEST_STATUSES.APPROVED]: z.record(z.nativeEnum(SUB_STATUS_APPROVED), z.boolean()),
        [LOANREQUEST_STATUSES.OFFER_AT_CUSTOMER]: z.record(z.nativeEnum(SUB_STATUS_OFFER_AT_CUSTOMER), z.boolean()),
        [LOANREQUEST_STATUSES.OFFER_AT_BANK]: z.record(z.nativeEnum(SUB_STATUS_OFFER_AT_BANK), z.boolean()),
    })
    .nullable();

export type SchemaTemplateResolver_GetStatusesWithDivisionMailTrigger = z.infer<
    typeof schemaTemplateResolver_GetStatusesWithDivisionMailTrigger
>;

export type TemplateResolver_GetStatusesWithDivisionMailTrigger = Resolver<
    Arguments,
    SchemaTemplateResolver_GetStatusesWithDivisionMailTrigger
>;
